import type { TutorTask } from './tutor-tasks/interfaces'

import { TaskStatus } from '@brighterly/lib-core-types/tutor/enums'

import { useListsStore } from '@shared/model'

interface DisciplineTaskStatusOptions {
  task: ComputedRef<TutorTask>
}

interface DisciplineTaskStatusReturn {
  refActorText: ComputedRef<string | null>
}

/** A canceled task names who canceled it ("by Admin"), when the actor was recorded. */
export const useDisciplineTaskStatus = ({ task }: DisciplineTaskStatusOptions): DisciplineTaskStatusReturn => {
  const listsStore = useListsStore()

  const refActorText = computed<string | null>(() => {
    const { status, actor_type: actorType } = task.value
    if (status !== TaskStatus.Canceled || !actorType) return null

    return `by ${listsStore.getLists?.tutor_task.actor_type[actorType] ?? actorType}`
  })

  return {
    refActorText,
  }
}
